export const baseEnvironment = {
  API_URL: '/baseEnvUrl',
  base: true,
  reqTimeout: 180000, // setting this to 40 secs, it's only applicable to exceptional cases.
  baseUrl: 'http://192.168.43.111:4001/api',
  azureClientId: '7f26bbad-0d50-4cdc-af9c-f33e42bb43d7',
  azureTenantId: '7cd4c483-9d86-49b2-ab98-97b0446f78af',
  azureRedirectURI: 'in.quanteon.starter://oauth/redirect',
  azureAuthorityURI: 'https://login.microsoftonline.com/',
  // sentryDNS:
  //   'https://cdae165d98ea4f319b1bdbc307cb08b7@o460272.ingest.sentry.io/5460207',
  apiVersion1: 'v1',
  apiVersion3: 'v3',
  apiEndPoints: {
    patientProcedureInformation: {
      surgeries: 'surgeries',
      clinicians: 'clinicians',
      priorSurgeryReports: 'prior-surgery-reports',
      surgery: 'surgery'
    },
    surgeryModalities: {
      modalities: 'surgery-modalities',
      otherModalities: 'other_modality_list'
    },
    anestheticVitals: {
      vitals: 'anesthetic-vitals',
      anesthetic_vitals_checkboxes_values:
        'anesthetic-vitals-checkboxes-values',
      updateVitals: 'anesthetic-vitals-update',
      updateVitalCheckBoxex: 'update-vital-checkboxes'
    },
    vitalsViews: {
      graph: 'anesthetic-vitals_graph',
      list: 'anesthetic-vitals_list'
    },
    anestheticSedativeBolusList: {
      sedativeBolusList: 'anesthetic_sedative_bolus_list'
    },
    anestheticNarcotics: {
      narcoticsList: 'anesthetic_narcotics_list'
    },
    concentration: {
      concentrationRates: 'anesthetic_units_list'
    },
    surgetyDiagnosis: {
      diagnosis: 'surgery-diagnosis'
    },
    auth: {
      azureSSOLogin: '/auth/azurelogin',
      loginUrl: '/auth/login'
    },
    surgeryInductionAnestheticAgents: {
      induction: '/induction'
    },
    surgeryTimes: {
      surgeryTimes: '/surgerytimes'
    },
    cadwellEvents: {
      cadwellEvents: '/cadwellevents'
    },
    ipChatLogs: {
      ipChatLogs: '/ipchatlogs'
    },
    usmon: {
      usmon: '/usmon'
    },
    printReports: {
      printReports: '/printreport'
    },
    anestheticInfusion: {
      anestheticInfusion: '/anestheticsinfusion'
    },
    surgeryCase: {
      summary: 'surgery-case-summary',
      restrictions: 'surgery-modality-restrictions'
    },
    upperSsep: {
      upperSsep: '/upperssep'
    },
    lowerSsep: {
      lowerSsep: '/lowerssep'
    },
    upperMep: {
      upperMep: '/uppermep'
    },
    lowerMep: {
      lowerMep: '/lowermep'
    },
    transabdominalMeps: {
      transabdominalMeps: '/surgery-modality/transabdominalmep'
    },
    upperEmg: {
      upperEmg: '/upperemg'
    },
    lowerEmg: {
      lowerEmg: '/loweremg'
    },
    absAxialEmg: {
      absAxialEmg: '/absaxialemg'
    },
    craniEmg: {
      craniEmg: '/craniemg'
    },
    anal: {
      anal: '/analsphincteremg'
    },
    urethral: {
      urethral: '/urethralsphincteremg'
    },
    baep: {
      baep: '/baepemg'
    },
    vep: {
      vep: '/vepemg'
    },
    snap: {
      snap: '/snapemg'
    },
    hreflex: {
      hreflex: '/hreflexemg'
    },
    mapping: {
      mapping: '/mappingemg'
    },
    dssep: {
      dssep: '/dssepemg'
    },
    eeg: {
      eeg: '/eeg'
    },
    other: {
      other: '/other_modality'
    },
    lateralApproach: {
      lateralApproach: '/lateralapproachemg'
    },
    triggreedEmg: {
      triggreedEmg: '/triggeereedemg'
    },
    thresholdTable: {
      thresholdTable: '/thresholdtable'
    },
    thresholdTableInsert: {
      thresholdTableInsert: '/thresholdtableinsert'
    },
    thresholdTableUpdate: {
      thresholdTableUpdate: '/threshold-update'
    },
    leftAlert: {
      leftAlert: '/insert-threshold-table-left-alert'
    },
    rihtAlert: {
      rightAlert: '/insert-threshold-table-right-alert'
    },
    getLeftAlert: {
      getLeftAlert: '/get-threshold-table-left-alert'
    },
    updateLeftAlert: {
      updateLeftAlert: '/update-threshold-left-alert'
    },
    getRightAlert: {
      getRightAlert: '/get-threshold-table-right-alert'
    },
    updateRightAlert: {
      updateRightAlert: '/update-threshold-right-alert'
    },
    additionalAlertIssuedGet: {
      additionalAlertIssuedGet: '/get-additional-alert-issued'
    },
    userLogoutUrl: {
      userLogoutUrl: '/user_logout'
    },
    users: {
      all: '/user/all',
      users: '/users',
      usersAudit: '/users/audit',
      me:'user/me',
      modules: '/modules'
    },
    additionalAlertIssueInsert: {
      additionalAlertIssueInsert: '/insert-additional-alert-issued'
    },
    additionalAlertIssueUpdate: {
      additionalAlertIssueUpdate: '/update-additional-alert-issued'
    },
    atbrPdf: {
      atbrPdf: '/atbr-pdf'
    },
    physicians: {
      all: '/physicians/all',
      physician: '/physician'
    },
    followUpCall: {
      followUpCall: '/follow-up-call'
    },
    getsurgeryModalities: {
      modalities: 'get-surgery-modalities'
    },
    updateTo4Modality: {
      updateTo4Modality: '/update-to4modality'
    },
    getTo4Modality: {
      getTo4Modality: '/get-to4modality'
    },
    anestheticInfusionUpdate: {
      anestheticInfusionUpdate: '/anesthetics-infusion-update'
    },
    uncheckAdditionalAlertIssueUpdate: {
      uncheckAdditionalAlertIssueUpdate: '/uncheck-additional-alert-issued'
    },
    deleteThresholdEntry: {
      deleteThresholdEntry: '/delete-threshold-entry'
    },
    textSummarization: {
      caseSummaryReport: 'text-summarization/case-summary',
      saveCaseSummaryReport: 'text-summarization/case-summary/save',
      savedCaseSummaryReport: 'text-summarization/case-summary/saved'
    },
    To4Muscles: {
      to4Muscles: 'to4_list'
    },
    tEMG: {
      tEMG: 'temg_list'
    },
    patientDocumentUpload: {
      requiredUploadDocuments: '/document_configuration',
      loginPatient: 'patient/login',
      sendOtp: 'patient/send-otp',
      uploadDocument: 'documents/upload',
      sendConsent: 'patient/send-consent',
      sendToUsmon: 'patient/send-to-usmon',
      sendDocUpload: 'patient/send-document-upload-link',
      updateNotificationPhone: 'patient/update-notification-phone',
      patientIds: 'documents/patient/:patientId/document-ids',
      patientDocuments: 'documents/patient/:patientId/document/:documentId',
      adminDocuments: 'documents/admin/patient/:patientId/document/:documentId',
      adminIds: 'documents/admin/patient/:patientId/document-ids'
    },
    case: {
      resetCases: '/reset-case',
      allCases: '/all-cases',
      updateCaseStatus: '/update-case-status'
    },
    feedback: {
      check: '/feedback-check',
      submit: '/feedback'
    },
    documentsSubmissionScreen: {
      getDocumentSubmissionList: '/surgery-documents/:surgeryId',
      documentResendToUSMON: '/surgery-documents/:surgeryId/upload-to-usmon',
      previewSubmittedDocuments:
        '/surgery-documents/:surgery_id/document/:surgery_document_id'
    },
    surgeryDocumentUpload: {
      getDocumentType: '/surgery-documents/configurations',
      saveDocumentType: '/surgery-documents/:surgeryId/document/:typeId/upload'
    },
    surgeryDetailsScreen: {
      getAllSurgeons: '/surgeon/all',
      getProfilePictureBySurgenId: '/surgeon/:surgeon_id/profile-picture',
      getSurgeryDetailsBySurgeonId: '/surgeon/:surgeon_id',
      updateSurgeonPreferences: '/surgeon/:surgeon_id/preference',
      getServiceLines: '/surgeon/service-lines'
    },
    surgeonForms: {
      list: '/surgeon-forms',
      details: '/surgeon-forms/:id',
      view: '/surgeon-forms/:id/view',
      download: '/surgeon-forms/:id/download',
      downloadSigned: '/surgeon-forms/:surgeon_id/form/:form_id/download',
      upload: '/surgeon-forms'
    },
    surgeryForms: {
      downloadForm: '/surgery-forms/download/:uuid'
    },
    patientForms: {
      getPatientFormsDetails: '/surgery-forms/:surgery_id/details',
      getPatientFormsHistory: '/surgery-forms/:surgery_id/history',
      getPatientFormsSymptoms: '/surgery-forms/:surgery_id/symptoms',
      getPatientFormsFormsData: '/surgery-forms/:surgery_id/forms',
      resetPatientData: '/surgery-forms/:surgery_id/reset-patient-data',
      download: '/surgery-forms/:surgery_id/form/:form_id/download',
      sendToUsmon: '/surgery-forms/:surgery_id/form/:form_id/send-to-usmon',
      sendEmailToPatient:
        '/surgery-forms/:surgery_id/form/:form_id/send-email-to-patient',
      getSelectedFormContent: '/surgery-forms/:surgery_id/form/content',
      saveSignedForm: '/surgery-forms/:surgery_id/sign-form'
    },
    offline: {
      offlinePush: '/offline/push',
      offlinePull: '/offline/pull',
      sync: 'sync',
      technicianProcedure: 'technician-procedure',
      surgeryForms: 'surgery-forms',
      anesthetics: 'anesthetics',
      caseWorkFlow: 'case-work-flow',
      patient: 'patient',
      modalities: 'modalities',
      vitals: 'vitals',
      caseSummary: 'case-summary',
      documentSubmission: 'document-submission/surgery-documents/:surgery_id',
      surgeryFormsWithId: 'surgery-forms/:surgery_id',
      documentSubmissionSync: 'document-submission/sync',
      surgeryFormsGetFile: 'surgery-forms/:surgery_id/:form_id/download'
    }
  }
};